import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

async function portalDefterCheck(data) {
    return await axios.post(`${BASE_URL}/portal/checkELedger`, data);
}

export { portalDefterCheck };
